// @flow

const formatDataVoiceSMSLabel = (label: string, suffix?: string): string => {
  const types = ['DATA', 'VOICE', 'SMS'];
  const targetType = types.find(type => label.includes(type));
  if (!targetType) return label;
  if (!suffix) return targetType;
  return targetType + suffix;
};

export default formatDataVoiceSMSLabel;
